'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef, useEffect, useMemo, useRef } from 'react';
import { useCombinedRefs } from '../../util';
import { Icon } from '../Icon';
import { Container, Item, OverflowDots } from './elements';
export const Breadcrumb = /*#__PURE__*/forwardRef(({
  children,
  maxItems,
  showOverflowDots = false,
  ariaLabel,
  ...rest
}, fRef) => {
  const innerRef = useRef();
  const combinedRef = useCombinedRefs(fRef, innerRef);
  const breadcrumbChildren = useMemo(() => maxItems ? React.Children.toArray(children).slice(-maxItems) : children, [children, maxItems]);
  useEffect(() => {
    var _innerRef$current, _innerRef$current$scr;
    const lastElementChild = innerRef.current.lastElementChild;
    (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : (_innerRef$current$scr = _innerRef$current.scroll) === null || _innerRef$current$scr === void 0 ? void 0 : _innerRef$current$scr.call(_innerRef$current, lastElementChild.offsetLeft, 0);
  }, []);
  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-aui": "breadcrumb",
    "aria-label": ariaLabel || 'breadcrumb',
    ref: combinedRef
  }, rest), showOverflowDots && /*#__PURE__*/React.createElement(OverflowDots, {
    color: "var(--aui-on-surface-soft)"
  }, "..."), React.Children.map(breadcrumbChildren, (child, index) => /*#__PURE__*/React.createElement(Item, {
    "aria-current": "page",
    key: index
  }, child, /*#__PURE__*/React.createElement(Icon.SSR, {
    src: "cards-navigation-chevron-right",
    size: "xsmall"
  }))));
});